import React from "react";
import Layout from "../../components/layout/index";

import Hero from "../../components/pe/Hero";
import Products from "../../components/pe/Product1";
import Products2 from "../../components/pe/Product2";
import SubscriptionOptions from "../../components/pe/PricingCard";
import PageContainer from "../../components/PageContainer";


const PeProduct = () => {
  return (
    <PageContainer
    title="PE-VC Transactions in India | Venture Intelligence"
    description="Track Private Equity & Venture Capital Investments & Exits and M&A deals involving Indian companies. Directory of PE-VC Investors and their portfolio companies."
  >
    <Layout>
      <Hero />
      <Products />
      <Products2 />
      <SubscriptionOptions />
    </Layout>
    </PageContainer>
  );
};

export default PeProduct;
